import React from 'react';
import Card from '../../../components/ui/Card';
import Icon from '../../../components/AppIcon';

const SqftMetricsGrid = ({ analytics }) => {
  const totalSqft = analytics?.reduce((sum, item) => sum + item?.totalSqft, 0);
  const totalOccupied = analytics?.reduce((sum, item) => sum + item?.occupiedSqft, 0);
  const totalRevenue = analytics?.reduce((sum, item) => sum + item?.totalRevenue, 0);
  const avgRevenuePerSqft = totalOccupied > 0 ? totalRevenue / totalOccupied : 0;
  const avgUtilization = totalSqft > 0 ? (totalOccupied / totalSqft) * 100 : 0;
  const totalPotential = analytics?.reduce((sum, item) => sum + item?.potentialRevenue, 0);

  const metrics = [
    {
      label: 'Total Sqft',
      value: totalSqft?.toLocaleString(),
      icon: 'Maximize2',
      bgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
      subtitle: `${totalOccupied?.toLocaleString()} occupied`
    },
    {
      label: 'Avg Revenue/Sqft',
      value: `₹${avgRevenuePerSqft?.toFixed(2)}`,
      icon: 'DollarSign',
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600',
      subtitle: 'Monthly average'
    },
    {
      label: 'Utilization Rate',
      value: `${avgUtilization?.toFixed(1)}%`,
      icon: 'TrendingUp',
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600',
      subtitle: 'Space efficiency'
    },
    {
      label: 'Potential Revenue',
      value: `₹${totalPotential?.toLocaleString()}`,
      icon: 'Target',
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-600',
      subtitle: 'From vacant space'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metrics?.map((metric, index) => (
        <Card key={index} className="p-4">
          <div className="flex items-start gap-3">
            <div className={`w-12 h-12 ${metric?.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon name={metric?.icon} className={`w-6 h-6 ${metric?.iconColor}`} />
            </div>
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-1">{metric?.label}</p>
              <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
              <p className="text-xs text-muted-foreground mt-1">{metric?.subtitle}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default SqftMetricsGrid;